import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { fetchOptionsAccount } from '../lib/optionsApi';
import { useOptionsLocale } from '../context/OptionsLanguageContext';

export const useOptionsPortfolioRiskData = (connected) => {
  const { t } = useOptionsLocale();
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadAccountData = useCallback(async () => {
    if (!connected) {
      setAccountData(null);
      return;
    }

    setLoading(true);
    try {
      const data = await fetchOptionsAccount();
      setAccountData(data);
    } catch (error) {
      toast.error(error.response?.data?.detail || t('toasts.failedLoadPositions'));
    } finally {
      setLoading(false);
    }
  }, [connected, t]);

  useEffect(() => {
    loadAccountData();
  }, [loadAccountData]);

  return {
    accountData,
    loading,
    reloadAccountData: loadAccountData,
  };
};

export default useOptionsPortfolioRiskData;